export const pagination = {
  data: [],
  total: 0,
  count: 50,
};
export const sorting = {
  sort_column_name: null,
  sort_direction: null, // ['ascending', 'descending', null]
}
